import { call, put } from 'redux-saga/effects';
import Logger from '../../services/logger';
import AppsAPI from '../../services/apps';
import { updateAttributionAppsData } from '../../actions/apps';

const logger = new Logger('[partnerConfiguration:saga]');
const appsApi = new AppsAPI();

function* onload() {
    try {
        const appsResponse = yield call(appsApi.getAttributionApps, false, true);

        if (appsResponse?.apps?.length) {
            yield put(updateAttributionAppsData(appsResponse));
        }
    } catch (e) {
        logger.debug('Error while loading apps', e);
    }
}

export { onload };